import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button,
    CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardPatentes from "components/Varios/CardPatentes.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class PatentesData {
    idhvpatente: number = 0;
    idpersona: number = 0;

    tipo: string = "";
    codigo: string = "";
    fecha: string = "";
    fechavigencia: string = "";
    origen: string = "";
    descripcion: string = "";

    idnomenclaturatit: number = 0;
    idareaconocim: number = 0;
    idsubareaconoc: number = 0;

    idareafrascati: number = 0;
    idsubareafrascati: number = 0;

    refarchivo1: string = "";
    refarchivo2: string = "";
    refarchivo3: string = "";

    strCampoamplio?: string = "";
    strCampodetallado?: string = "";
    strCampoespecifico?: string = "";
}

interface PatentesDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: PatentesData;
    PatentesDataList: PatentesData[];
    tiposList: Array<any>;
    areaCINEList: Array<any>;
    subAreaCINEList: Array<any>;
    materiaCINEList: Array<any>;
    areaFrascatiList: Array<any>;
    subAreaFrascatiList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class Patentes extends React.Component<RouteComponentProps<{}>, PatentesDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new PatentesData(),
            PatentesDataList: [], tiposList: [], areaCINEList: [], subAreaCINEList: [], materiaCINEList: [], areaFrascatiList: [], subAreaFrascatiList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarPatentes = this.cargarPatentes.bind(this);
        this.cargarSubAreaCINE = this.cargarSubAreaCINE.bind(this);
        this.cargarMaterias = this.cargarMaterias.bind(this);
        this.cargarSubAreaFrascati = this.cargarSubAreaFrascati.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarPatentes();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        // API PARA OBTENER TIPO
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO PATENTE")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        //console.log(result)
                        this.setState({
                            tiposList: result.entTabla.map(d => ({
                                "value": String(d.codigo),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los tipos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tiposList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS DE CONOCMIENTO CINE
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoAmplio/0/0/0/00")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            areaCINEList: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas de conocimiento CINE.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        areaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS FRASCATI
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/" + "AREA FRASCATI")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            areaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas FRASCATI.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        areaFrascatiList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarPatentes() {
        fetch(API_URL + "DatosEscalafon/PatentesDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            PatentesDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener La patente.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        PatentesDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaFrascati(idcatalogopadre, change = true) {
        var dto = this.state.dtoData;
        dto["idareafrascati"] = idcatalogopadre;
        if (change) {
            dto['idsubareafrascati'] = 0;
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogoSubAreaFrascatiByCodigo/" + idcatalogopadre)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            subAreaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas FRASCATI.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        subAreaFrascatiList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaCINE(strCampoamplio, change = true) {
        var dto = this.state.dtoData;
        dto["strCampoamplio"] = strCampoamplio;
        if (change) {
            dto['strCampoespecifico'] = "";
            dto['strCampodetallado'] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoEspecifico/0/0/00/" + strCampoamplio)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            subAreaCINEList: result.entTabla.map(d => ({
                                "value": d.campoespecifico,
                                "label": d.nombrecampoe
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas CINE.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        subAreaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarMaterias(strCampoespecifico, change = true) {
        var dto = this.state.dtoData;
        dto["strCampoespecifico"] = strCampoespecifico;
        if (change) {
            dto['strCampodetallado'] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoDetallado/0/00/" + dto.strCampoamplio + "/" + strCampoespecifico)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            materiaCINEList: result.entTabla.map(d => ({
                                "value": d.idnomenclaturatit,
                                "label": d.nombrecampod
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las materias CINE.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        materiaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "idnomenclaturatit") {
            dto["strCampodetallado"] = value;
        }

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });
    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "PA1", "label": "Evidencia de patente" + filesData.filter(f => f.type == "PA1").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "PA2", "label": "Evidencia 2 de patente" + filesData.filter(f => f.type == "PA2").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "PA3", "label": "Evidencia 3 de patente" + filesData.filter(f => f.type == "PA3").map(ff => ': ' + ff.file.name).join(', ') }
        ];
        //console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: PatentesData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo1) {
            evidencias.push({ name: "PA" + this.state.currentUser.identificacion + "-1.PDF", url: API_URL + "DatosEscalafon/RefarchivoPatente/1/" + infoAcademica.idhvpatente });
        }
        if (infoAcademica.refarchivo2) {
            evidencias.push({ name: "PA" + this.state.currentUser.identificacion + "-2.PDF", url: API_URL + "DatosEscalafon/RefarchivoPatente/2/" + infoAcademica.idhvpatente });
        }
        if (infoAcademica.refarchivo3) {
            evidencias.push({ name: "PA" + this.state.currentUser.identificacion + "-3.PDF", url: API_URL + "DatosEscalafon/RefarchivoPatente/3/" + infoAcademica.idhvpatente });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new PatentesData() });
    }

    onClickEdit(idhvpatente) {
        this.setState({
            dtoData: new PatentesData()
        });

        fetch(API_URL + "DatosEscalafon/PatentesByIdpatente/" + idhvpatente)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        if (result.entTabla[0]["strCampoamplio"]) {
                            this.cargarSubAreaCINE(result.entTabla[0]["strCampoamplio"], false)
                        }

                        if (result.entTabla[0]["strCampoespecifico"]) {
                            this.cargarMaterias(result.entTabla[0]["strCampoespecifico"], false)
                        }

                        if (result.entTabla[0]["idareafrascati"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati"], false)
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new PatentesData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idhvpatente) {
        fetch(API_URL + "FormularioController/DeleteDatosPatente/" + idhvpatente, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La patente se eliminó correctamente.")
                        this.cargarPatentes();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append(fileData.type, fileData.file, fileData.file.name);
            });

            formFilesData.append('idpatente', identidad);
            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar las evidencias.")
                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("Las evidencias se cargaron exitosamente");
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fecha' || clave === 'fechavigencia') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

            if (clave === "idnomenclaturatit") {
                dto["strCampodetallado"] = String(value);
            }
        });

        if (formIsValid) {
            delete dto['strCampoamplio'];
            delete dto['strCampoespecifico'];
            delete dto['strCampodetallado'];
            delete dto['strareacampoamplio'];
            delete dto['strareacampoespecifico'];
            delete dto['strareacampodetallado'];
            delete dto['strareafrascati'];
            delete dto['strsubareafrascati'];
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idhvpatente === 0) {
                fetch(API_URL + "FormularioController/PostDatosPatente", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La patente se ha actualizado correctamente.");

                                this.postFiles("FormularioController/PostFilesDatosEscalafon/Patentes", filesData, responseJson.entidad.idhvpatente);

                                this.cargarPatentes();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosPatente", {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La patente se ha registrado correctamente.");

                                this.postFiles("FormularioController/PostFilesDatosEscalafon/Patentes", filesData, responseJson.entidad.idhvpatente);

                                this.onClickLimpiar();
                                this.cargarPatentes();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }
    }

    public render() {
        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.PatentesDataList, this.state.tiposList, this.state.tiposEvidencia, this.state.areaCINEList,
                this.state.subAreaCINEList, this.state.materiaCINEList, this.state.areaFrascatiList, this.state.subAreaFrascatiList);
        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(PatentesDataList: Array<any>, tiposList: Array<any>, tiposEvidencia: Array<any>, areaCINEList: Array<any>, subAreaCINEList: Array<any>,
        materiaCINEList: Array<any>, areaFrascatiList: Array<any>, subAreaFrascatiList: Array<any>,) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Propiedad intelectual (patente, derecho de autor, nuevas obtenciones vegetales, secreto empresarial)</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="tipo">Tipo*</Label>
                                                    <SelectItem
                                                        options={tiposList}
                                                        value={this.state.dtoData.tipo ? this.state.dtoData.tipo.trim() : ""}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipo"
                                                        id="tipo"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="codigo">Código*</Label>
                                                    <Input maxLength="20" name="codigo" id="codigo" value={this.state.dtoData.codigo} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fecha">Fecha patente*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fecha}
                                                    name="fecha"
                                                    id="fecha"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fechavigencia">Fecha vigencia*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fechavigencia}
                                                    name="fechavigencia"
                                                    id="fechavigencia"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipoidentificacion">Origen*</Label>
                                                    <Row>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-5 ml-1"
                                                                type="radio"
                                                                checked={this.state.dtoData.origen === "N"}
                                                                value="N"
                                                                id="origen"
                                                                name="origen"
                                                                onChange={this.handleChange}
                                                                label="Nacional"
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="E"
                                                                id="origen2"
                                                                name="origen"
                                                                checked={this.state.dtoData.origen === "E"}
                                                                onChange={this.handleChange}
                                                                label="Extranjera"
                                                            />
                                                        </Col>
                                                    </Row>

                                                </FormGroup>
                                            </Col>
                                            <Col md={9}>
                                                <FormGroup>
                                                    <Label for="descripcion">Descripción*</Label>
                                                    <Input maxLength="500" type="textarea" name="descripcion" id="descripcion" value={this.state.dtoData.descripcion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia resolución QA</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="PA1"
                                                            placeholder={this.state.dtoData.refarchivo1 ? "Actualizar Evidencia 1" : "Subir Evidencia 1"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 1"
                                                        id="downloadRef1"
                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                        name={"PA" + this.state.currentUser.identificacion + "-1.PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoPatente/1/" + this.state.dtoData.idhvpatente}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="PA2"
                                                            placeholder={this.state.dtoData.refarchivo2 ? "Actualizar Evidencia 2" : "Subir Evidencia 2"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 2"
                                                        id="downloadRef2"
                                                        refarchivo={this.state.dtoData.refarchivo2}
                                                        name={"PA" + this.state.currentUser.identificacion + "-2.PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoPatente/2/" + this.state.dtoData.idhvpatente}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="PA3"
                                                            placeholder={this.state.dtoData.refarchivo3 ? "Actualizar Evidencia 3" : "Subir Evidencia 3"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 3"
                                                        id="downloadRef3"
                                                        refarchivo={this.state.dtoData.refarchivo3}
                                                        name={"PA" + this.state.currentUser.identificacion + "-3.PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoPatente/3/" + this.state.dtoData.idhvpatente}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <br />
                                        <br />

                                        <Row form>
                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO CINE</p>
                                                <FormGroup row>
                                                    <Col md={4} className="">
                                                        <Label for="idpais">Área de conocimiento <br /> CINE en función del título*</Label>
                                                        <SelectItem
                                                            options={areaCINEList}
                                                            value={this.state.dtoData.strCampoamplio}
                                                            onChange={this.cargarSubAreaCINE}
                                                            placeholder=""
                                                            name="strCampoamplio"
                                                            id="strCampoamplio"
                                                            icon="fa-caret-right"
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampoespecifico">Sub-Área de  <br /> conocimiento CINE*</Label>
                                                        <SelectItem
                                                            options={subAreaCINEList}
                                                            value={this.state.dtoData.strCampoespecifico}
                                                            onChange={this.cargarMaterias}
                                                            placeholder=""
                                                            name="strCampoespecifico"
                                                            id="strCampoespecifico"
                                                            icon="fa-caret-right"
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampodetallado">Área de conocimiento <br /> (materias)*</Label>
                                                        <SelectItem
                                                            options={materiaCINEList}
                                                            value={this.state.dtoData.idnomenclaturatit}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idnomenclaturatit"
                                                            id="strCampodetallado"
                                                            icon="fa-caret-right"
                                                        />
                                                    </Col>
                                                </FormGroup>

                                            </Col>

                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO FRASCATI</p>
                                                <FormGroup row>
                                                    <Col md={6} className="">
                                                        <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título*</Label>
                                                        <SelectItem
                                                            options={areaFrascatiList}
                                                            value={this.state.dtoData.idareafrascati}
                                                            onChange={this.cargarSubAreaFrascati}
                                                            placeholder=""
                                                            name="idareafrascati"
                                                            id="idareafrascati"
                                                            icon="fa-caret-right"
                                                        />
                                                    </Col>
                                                    <Col md={6} className="">
                                                        <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI*</Label>
                                                        <SelectItem
                                                            options={subAreaFrascatiList}
                                                            value={this.state.dtoData.idsubareafrascati}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idsubareafrascati"
                                                            id="idsubareafrascati"
                                                            icon="fa-caret-right"
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {PatentesDataList.map((dto, index) =>
                                                <CardPatentes
                                                    key={dto.idhvpatente}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + PatentesDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idhvpatente)}
                                                    eventDelete={() => this.onClickDelete(dto.idhvpatente)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Patentes;